module.exports = __webpack_public_path__ + "img/task.d0eb9d9d.svg";